import { HotelSearchData } from '@/types/hotel-search';
import { supabase } from '@/lib/supabase/client';

export const MOCK_HOTEL_SEARCH: HotelSearchData = {
  search_id: 'search_japan_2026_001',
  generated_at: '2026-05-14T19:22:00Z',
  checkin: '2026-10-10',
  checkout: '2026-10-15',
  nights: 5,
  guests: 2,
  currency: 'USD',
  destinations: [
    {
      municipality: 'Tokyo',
      country: 'Japan',
      coordinates: { lat: 35.6764, lng: 139.6500 },
      checkin: '2026-10-10',
      checkout: '2026-10-12',
      nights: 2,
      hotels: [
        {
          hotel_id: 'f2d2c6f2-53b1-4d65-8d49-1a0f2b11f001',
          hotel_slug: 'aman_tokyo',
          name: 'Aman Tokyo',
          availability: true,
          keywords: ['minimalist luxury', 'wellness', 'quiet', 'exclusive', 'design-forward'],
          google_maps_url: 'https://www.google.com/maps/place/Aman+Tokyo',
          booking_url: 'https://www.booking.com/hotel/jp/aman-tokyo.en-gb.html',
          coordinates: { lat: 35.6872, lng: 139.7651 },
          external_ids: { booking_hotel_id: '9468400', google_place_id: 'ChIJf_tokyo_aman_mocked' },
          location: { address: 'The Otemachi Tower, 1-5-6 Otemachi, Chiyoda', city: 'Tokyo', country: 'Japan' },
          classification: { stars: 5, label: '5 out of 5 stars' },
          google_reviews: { rating: 4.8, review_count: 2143 },
          rating: { score: 9.6, label: 'Exceptional', review_count: 842 },
          price_summary: { currency: 'USD', min_per_night: 2370, max_per_night: 3080, min_total: 11850, max_total: 15400 },
          facilities: { most_popular: ['Indoor swimming pool', 'Spa and wellness centre', 'Fitness centre', 'Fine dining restaurant', 'Bar', 'Room service', 'Free Wi-Fi', 'City view'] },
          images: ['https://picsum.photos/seed/aman1/1200/800', 'https://picsum.photos/seed/aman2/1200/800', 'https://picsum.photos/seed/aman3/1200/800', 'https://picsum.photos/seed/aman4/1200/800'],
          description: 'Ultra refined urban sanctuary blending Japanese minimalism with world-class wellness and panoramic skyline views from the Otemachi Tower.',
          rooms: [
            {
              name: 'Deluxe Suite',
              max_persons: 2,
              rate_options: [{
                room_name: 'Deluxe Suite', block_id: '946840001_417179323_2_85_0',
                price: 'USD 11,850', total: 'USD 11,850', original_price: '', per_night: 'USD 2,370',
                discount: '', discount_type: '', taxes_and_charges: '+USD 1,280 taxes and charges',
                taxes_and_charges_details: [{ category: 'aggregate', label: 'taxes and charges', raw: '+USD 1,280 taxes and charges', amount: 'USD 1,280', currency: 'USD', percentage: null, basis: 'aggregate' }],
                rate_options: ['Breakfast Included', 'Free cancellation before 26 September 2026', 'Pay at the property']
              }]
            },
            {
              name: 'Panoramic Suite',
              max_persons: 2,
              rate_options: [{
                room_name: 'Panoramic Suite', block_id: '946840002_417179323_2_85_0',
                price: 'USD 15,400', total: 'USD 15,400', original_price: 'USD 18,200', per_night: 'USD 3,080',
                discount: 'USD 2,800', discount_type: 'Early Booker Deal', taxes_and_charges: '+USD 1,680 taxes and charges',
                taxes_and_charges_details: [{ category: 'aggregate', label: 'taxes and charges', raw: '+USD 1,680 taxes and charges', amount: 'USD 1,680', currency: 'USD', percentage: null, basis: 'aggregate' }],
                rate_options: ['Breakfast Included', 'Non-refundable', 'Pay in advance', 'Early Booker Deal', '15% off']
              }]
            }
          ]
        },
        {
          hotel_id: 'f51a1b6c-0f0f-4c81-92cb-1f9f2cb11002',
          hotel_slug: 'hoshi_palace_tokyo',
          name: 'Hoshi Palace Tokyo',
          availability: true,
          keywords: ['city views', 'executive', 'modern', 'luxury', 'central location'],
          google_maps_url: 'https://www.google.com/maps/place/Hoshi+Palace+Tokyo',
          booking_url: 'https://www.booking.com/hotel/jp/hoshi-palace-tokyo.en-gb.html',
          coordinates: { lat: 35.6897, lng: 139.6922 },
          external_ids: { booking_hotel_id: '9468401', google_place_id: 'ChIJf_tokyo_hoshi_mocked' },
          location: { address: '2-10-3 Nagatacho, Chiyoda', city: 'Tokyo', country: 'Japan' },
          classification: { stars: 5, label: '5 out of 5 stars' },
          google_reviews: { rating: 4.6, review_count: 1874 },
          rating: { score: 9.1, label: 'Superb', review_count: 612 },
          price_summary: { currency: 'USD', min_per_night: 1590, max_per_night: 2240, min_total: 7950, max_total: 11200 },
          facilities: { most_popular: ['Outdoor swimming pool', 'Fitness centre', 'Fine dining restaurant', 'Bar', 'Room service', 'Free Wi-Fi', 'Business centre', 'Airport shuttle'] },
          images: ['https://picsum.photos/seed/hoshi1/1200/800', 'https://picsum.photos/seed/hoshi2/1200/800', 'https://picsum.photos/seed/hoshi3/1200/800'],
          description: 'Contemporary luxury hotel in central Tokyo offering skyline suites, refined Japanese hospitality and seamless access to the business and cultural districts.',
          rooms: [
            {
              name: 'Superior King Room',
              max_persons: 2,
              rate_options: [
                {
                  room_name: 'Superior King Room', block_id: '946840101_417179400_2_85_0',
                  price: 'USD 7,950', total: 'USD 7,950', original_price: '', per_night: 'USD 1,590',
                  discount: '', discount_type: '', taxes_and_charges: '+USD 890 taxes and charges',
                  taxes_and_charges_details: [{ category: 'aggregate', label: 'taxes and charges', raw: '+USD 890 taxes and charges', amount: 'USD 890', currency: 'USD', percentage: null, basis: 'aggregate' }],
                  rate_options: ['Room Only', 'Free cancellation before 3 October 2026', 'Pay at the property']
                },
                {
                  room_name: 'Superior King Room', block_id: '946840101_417179401_2_85_0',
                  price: 'USD 8,600', total: 'USD 8,600', original_price: '', per_night: 'USD 1,720',
                  discount: '', discount_type: '', taxes_and_charges: '+USD 960 taxes and charges',
                  taxes_and_charges_details: [{ category: 'aggregate', label: 'taxes and charges', raw: '+USD 960 taxes and charges', amount: 'USD 960', currency: 'USD', percentage: null, basis: 'aggregate' }],
                  rate_options: ['Breakfast Included', 'Free cancellation before 3 October 2026', 'Pay at the property']
                }
              ]
            },
            {
              name: 'Skyline Suite',
              max_persons: 2,
              rate_options: [{
                room_name: 'Skyline Suite', block_id: '946840102_417179402_2_85_0',
                price: 'USD 11,200', total: 'USD 11,200', original_price: '', per_night: 'USD 2,240',
                discount: '', discount_type: '', taxes_and_charges: '+USD 1,230 taxes and charges',
                taxes_and_charges_details: [{ category: 'aggregate', label: 'taxes and charges', raw: '+USD 1,230 taxes and charges', amount: 'USD 1,230', currency: 'USD', percentage: null, basis: 'aggregate' }],
                rate_options: ['Breakfast Included', 'Non-refundable', 'Pay in advance']
              }]
            }
          ]
        }
      ]
    },
    {
      municipality: 'Kyoto',
      country: 'Japan',
      coordinates: { lat: 35.0116, lng: 135.7681 },
      checkin: '2026-10-12',
      checkout: '2026-10-14',
      nights: 2,
      hotels: [
        {
          hotel_id: '8e27a6b5-74f1-4bb5-a4b0-7b21b10ac002',
          hotel_slug: 'noma_cliffside_retreat',
          name: 'Noma Cliffside Retreat',
          availability: true,
          keywords: ['boutique', 'zen', 'luxury ryokan', 'romantic', 'private onsen'],
          google_maps_url: 'https://www.google.com/maps/place/Noma+Cliffside+Retreat',
          booking_url: 'https://www.booking.com/hotel/jp/noma-cliffside-retreat.en-gb.html',
          coordinates: { lat: 35.0241, lng: 135.7635 },
          external_ids: { booking_hotel_id: '8127331', google_place_id: 'ChIJf_kyoto_noma_mocked' },
          location: { address: '12 Minamigawara-cho, Higashiyama', city: 'Kyoto', country: 'Japan' },
          classification: { stars: 5, label: '5 out of 5 stars' },
          google_reviews: { rating: 4.7, review_count: 1389 },
          rating: { score: 9.3, label: 'Superb', review_count: 516 },
          price_summary: { currency: 'USD', min_per_night: 1240, max_per_night: 1980, min_total: 6200, max_total: 9900 },
          facilities: { most_popular: ['Private onsen (hot spring bath)', 'Spa and wellness centre', 'Traditional kaiseki restaurant', 'Tea ceremony room', 'Zen garden', 'Room service', 'Free Wi-Fi', 'Airport transfer'] },
          images: ['https://picsum.photos/seed/noma1/1200/800', 'https://picsum.photos/seed/noma2/1200/800', 'https://picsum.photos/seed/noma3/1200/800', 'https://picsum.photos/seed/noma4/1200/800'],
          description: 'Luxury Kyoto retreat blending ryokan traditions with boutique design. Nestled in Higashiyama with private wellness experiences, stone gardens and curated cultural immersion.',
          rooms: [
            {
              name: 'Zen Suite with Private Onsen',
              max_persons: 2,
              rate_options: [{
                room_name: 'Zen Suite with Private Onsen', block_id: '812733101_517179323_2_85_0',
                price: 'USD 6,200', total: 'USD 6,200', original_price: '', per_night: 'USD 1,240',
                discount: '', discount_type: '', taxes_and_charges: '+USD 680 taxes and charges',
                taxes_and_charges_details: [{ category: 'aggregate', label: 'taxes and charges', raw: '+USD 680 taxes and charges', amount: 'USD 680', currency: 'USD', percentage: null, basis: 'aggregate' }],
                rate_options: ['Breakfast Included', 'Free cancellation before 9 October 2026', 'Pay at the property']
              }]
            },
            {
              name: 'Garden Villa with Open-Air Bath',
              max_persons: 2,
              rate_options: [{
                room_name: 'Garden Villa with Open-Air Bath', block_id: '812733102_517179324_2_85_0',
                price: 'USD 9,900', total: 'USD 9,900', original_price: 'USD 11,500', per_night: 'USD 1,980',
                discount: 'USD 1,600', discount_type: 'Getaway Deal', taxes_and_charges: '+USD 1,080 taxes and charges',
                taxes_and_charges_details: [{ category: 'aggregate', label: 'taxes and charges', raw: '+USD 1,080 taxes and charges', amount: 'USD 1,080', currency: 'USD', percentage: null, basis: 'aggregate' }],
                rate_options: ['Half Board', 'Non-refundable', 'Pay in advance', 'Getaway Deal', '14% off']
              }]
            }
          ]
        },
        {
          hotel_id: '7ca18a2b-93fd-43fd-a4b3-c8218ac31003',
          hotel_slug: 'sakura_house_kyoto',
          name: 'Sakura House Kyoto',
          availability: true,
          keywords: ['traditional', 'quiet', 'garden', 'authentic', 'tatami'],
          google_maps_url: 'https://www.google.com/maps/place/Sakura+House+Kyoto',
          booking_url: 'https://www.booking.com/hotel/jp/sakura-house-kyoto.en-gb.html',
          coordinates: { lat: 35.0094, lng: 135.7542 },
          external_ids: { booking_hotel_id: '8127332', google_place_id: 'ChIJf_kyoto_sakura_mocked' },
          location: { address: '34 Nishikujo Toin-cho, Minami', city: 'Kyoto', country: 'Japan' },
          classification: { stars: 4, label: '4 out of 5 stars' },
          google_reviews: { rating: 4.8, review_count: 954 },
          rating: { score: 9.0, label: 'Superb', review_count: 402 },
          price_summary: { currency: 'USD', min_per_night: 820, max_per_night: 1240, min_total: 4100, max_total: 6200 },
          facilities: { most_popular: ['Traditional Japanese breakfast', 'Private garden', 'Communal hot spring bath', 'Tea room', 'Yukata provided', 'Free Wi-Fi', 'Bicycle rental', '24-hour front desk'] },
          images: ['https://picsum.photos/seed/sakura1/1200/800', 'https://picsum.photos/seed/sakura2/1200/800', 'https://picsum.photos/seed/sakura3/1200/800'],
          description: 'Traditional Kyoto ryokan with tatami suites, private gardens and immersive cultural hospitality. Walking distance from Fushimi Inari and Tofuku-ji.',
          rooms: [
            {
              name: 'Standard Tatami Room',
              max_persons: 2,
              rate_options: [{
                room_name: 'Standard Tatami Room', block_id: '812733201_517179500_2_85_0',
                price: 'USD 4,100', total: 'USD 4,100', original_price: '', per_night: 'USD 820',
                discount: '', discount_type: '', taxes_and_charges: '+USD 450 taxes and charges',
                taxes_and_charges_details: [{ category: 'aggregate', label: 'taxes and charges', raw: '+USD 450 taxes and charges', amount: 'USD 450', currency: 'USD', percentage: null, basis: 'aggregate' }],
                rate_options: ['Japanese Breakfast Included', 'Free cancellation before 5 October 2026', 'Pay at the property']
              }]
            },
            {
              name: 'Garden Suite',
              max_persons: 2,
              rate_options: [{
                room_name: 'Garden Suite', block_id: '812733202_517179501_2_85_0',
                price: 'USD 6,200', total: 'USD 6,200', original_price: '', per_night: 'USD 1,240',
                discount: '', discount_type: '', taxes_and_charges: '+USD 680 taxes and charges',
                taxes_and_charges_details: [{ category: 'aggregate', label: 'taxes and charges', raw: '+USD 680 taxes and charges', amount: 'USD 680', currency: 'USD', percentage: null, basis: 'aggregate' }],
                rate_options: ['Half Board', 'Free cancellation before 5 October 2026', 'Pay at the property']
              }]
            }
          ]
        }
      ]
    },
    {
      municipality: 'Osaka',
      country: 'Japan',
      coordinates: { lat: 34.6937, lng: 135.5023 },
      checkin: '2026-10-14',
      checkout: '2026-10-15',
      nights: 1,
      hotels: [
        {
          hotel_id: 'd91a12a9-771c-4fd4-a8d1-9b3efef71005',
          hotel_slug: 'aurora_urban_resort_osaka',
          name: 'Aurora Urban Resort Osaka',
          availability: true,
          keywords: ['modern', 'luxury', 'city lifestyle', 'food scene', 'design hotel'],
          google_maps_url: 'https://www.google.com/maps/place/Aurora+Urban+Resort+Osaka',
          booking_url: 'https://www.booking.com/hotel/jp/aurora-urban-resort-osaka.en-gb.html',
          coordinates: { lat: 34.7011, lng: 135.4955 },
          external_ids: { booking_hotel_id: '9901201', google_place_id: 'ChIJf_osaka_aurora_mocked' },
          location: { address: '3-2-4 Nakanoshima, Kita', city: 'Osaka', country: 'Japan' },
          classification: { stars: 5, label: '5 out of 5 stars' },
          google_reviews: { rating: 4.8, review_count: 1678 },
          rating: { score: 9.4, label: 'Superb', review_count: 694 },
          price_summary: { currency: 'USD', min_per_night: 1680, max_per_night: 2490, min_total: 8400, max_total: 12450 },
          facilities: { most_popular: ['Rooftop infinity pool', 'Spa and wellness centre', 'Michelin-recommended restaurant', 'Rooftop bar', 'Fitness centre', 'Free Wi-Fi', 'Concierge', 'Airport shuttle'] },
          images: ['https://picsum.photos/seed/aurora1/1200/800', 'https://picsum.photos/seed/aurora2/1200/800', 'https://picsum.photos/seed/aurora3/1200/800', 'https://picsum.photos/seed/aurora4/1200/800'],
          description: 'High-end Osaka hotel focused on gastronomy, nightlife access and contemporary Japanese luxury. Perched above Nakanoshima with sweeping river views and direct access to the vibrant food scene.',
          rooms: [
            {
              name: 'Deluxe River View Room',
              max_persons: 2,
              rate_options: [
                {
                  room_name: 'Deluxe River View Room', block_id: '990120101_617179323_2_85_0',
                  price: 'USD 8,400', total: 'USD 8,400', original_price: '', per_night: 'USD 1,680',
                  discount: '', discount_type: '', taxes_and_charges: '+USD 920 taxes and charges',
                  taxes_and_charges_details: [{ category: 'aggregate', label: 'taxes and charges', raw: '+USD 920 taxes and charges', amount: 'USD 920', currency: 'USD', percentage: null, basis: 'aggregate' }],
                  rate_options: ['Room Only', 'Free cancellation before 2 October 2026', 'Pay at the property']
                },
                {
                  room_name: 'Deluxe River View Room', block_id: '990120101_617179324_2_85_0',
                  price: 'USD 9,100', total: 'USD 9,100', original_price: '', per_night: 'USD 1,820',
                  discount: '', discount_type: '', taxes_and_charges: '+USD 990 taxes and charges',
                  taxes_and_charges_details: [{ category: 'aggregate', label: 'taxes and charges', raw: '+USD 990 taxes and charges', amount: 'USD 990', currency: 'USD', percentage: null, basis: 'aggregate' }],
                  rate_options: ['Breakfast Included', 'Free cancellation before 2 October 2026', 'Pay at the property']
                }
              ]
            },
            {
              name: 'Executive Panorama Suite',
              max_persons: 2,
              rate_options: [{
                room_name: 'Executive Panorama Suite', block_id: '990120102_617179325_2_85_0',
                price: 'USD 12,450', total: 'USD 12,450', original_price: 'USD 14,800', per_night: 'USD 2,490',
                discount: 'USD 2,350', discount_type: 'Genius', taxes_and_charges: '+USD 1,360 taxes and charges',
                taxes_and_charges_details: [
                  { category: 'excluded', label: 'City tax', raw: 'City tax: USD 8 per person per night', amount: 'USD 8', currency: 'USD', percentage: null, basis: 'per_person_per_night' },
                  { category: 'aggregate', label: 'taxes and charges', raw: '+USD 1,360 taxes and charges', amount: 'USD 1,360', currency: 'USD', percentage: null, basis: 'aggregate' }
                ],
                rate_options: ['Breakfast Included', 'Non-refundable', 'Pay in advance', 'Genius', '16% off']
              }]
            }
          ]
        }
      ]
    }
  ]
};

export async function seedMockSearch(): Promise<string | null> {
  try {
    const { data: existing } = await supabase
      .from('hotel_searches')
      .select('id')
      .eq('search_id', MOCK_HOTEL_SEARCH.search_id)
      .maybeSingle();

    if (existing) return existing.id;

    const { data: search, error } = await supabase
      .from('hotel_searches')
      .insert({
        search_id: MOCK_HOTEL_SEARCH.search_id,
        checkin: MOCK_HOTEL_SEARCH.checkin,
        checkout: MOCK_HOTEL_SEARCH.checkout,
        guests: MOCK_HOTEL_SEARCH.guests,
        currency: MOCK_HOTEL_SEARCH.currency,
        raw_data: MOCK_HOTEL_SEARCH,
      })
      .select()
      .single();

    if (error) throw error;

    const selections = MOCK_HOTEL_SEARCH.destinations.flatMap(dest =>
      dest.hotels.map((hotel, idx) => ({
        search_id: MOCK_HOTEL_SEARCH.search_id,
        hotel_id: hotel.hotel_id,
        municipality: dest.municipality,
        status: 'chosen',
        position: idx,
        comments: null,
      }))
    );

    await supabase.from('hotel_selections').insert(selections);

    return search?.id ?? null;
  } catch (err) {
    console.error('Error seeding mock search:', err);
    return null;
  }
}
